import { isStaleClientAssetError } from './isStaleClientAssetError';

/**
 * Client-side noise that should not alert (extensions, stale deploy chunks).
 */
const isBenignClientNoise = (error: unknown): boolean => {
  if (error == null) {
    return false;
  }

  const message =
    typeof (error as { message?: unknown }).message === 'string'
      ? (error as { message: string }).message
      : String(error);

  if (/Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/i.test(message)) {
    return true;
  }

  return isStaleClientAssetError(error);
};

export { isBenignClientNoise };
